/** True if `window` is not `undefined` */
export const IS_BROWSER = typeof window !== 'undefined'
